import Vue from 'vue'
import Router from 'vue-router'
import firebase from 'firebase'
const Home = () => import('@/components/Home')
const Library = () => import('@/components/Library')
const Upload = () => import('@/components/Upload')
const SignIn = () => import('@/components/SignIn')
const SignUp = () => import('@/components/SignUp')
const Read = () => import('@/components/Read')
const About = () => import('@/components/About')
const Contact = () => import('@/components/Contact')
const PGFooter = () => import('@/components/PGFooter')
const TermsOfUse = () => import('@/components/TermsOfUse')
const Privacy = () => import('@/components/Privacy')
const FAQ = () => import('@/components/FAQ')
const Notes = () => import('@/components/Notes')
const Search = () => import('@/components/Search')
const Preview = () => import('@/components/Preview')
const AccountSettings = () => import('@/components/AccountSettings')
const ResetPassword = () => import('@/components/ResetPassword')
const PastQandA = () => import('@/components/PastQandA')
const AudioNotes = () => import('@/components/AudioNotes')
const Listen = () => import('@/components/Listen')
const VerifyEmail = () => import('@/components/VerifyEmail')

Vue.use(Router)

let router = new Router({
  mode: 'history',
  base: __dirname,
  routes: [
    {
      path: '*',
      redirect: '/index'
    },
    {
      path: '/',
      component: Home
    },
    {
      path: '/library',
      component: Library,
      meta: { requiresAuth: true }
    },
    {
      path: '/upload',
      component: Upload,
      meta: { requiresAuth: true }
    },
    {
      path: '/contact',
      component: Contact
    },
    {
      path: '/about',
      component: About
    },
    {
      path: '/pg-footer',
      component: PGFooter
    },
    {
      path: '/sign-in',
      component: SignIn,
      props: true
    },
    {
      path: '/sign-up',
      component: SignUp
    },
    {
      path: '/read/:path/:type/:id',
      component: Read,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: '/terms',
      component: TermsOfUse
    },
    {
      path: '/privacy',
      component: Privacy
    },
    {
      path: '/faq',
      component: FAQ
    },
    {
      path: '/notes',
      component: Notes,
      props: true
    },
    {
      path: '/search/:query',
      component: Search,
      props: true
    },
    {
      path: '/preview/:type/:klass/:subject/:id',
      component: Preview,
      props: true
    },
    {
      path: '/settings',
      component: AccountSettings,
      meta: { requiresAuth: true }
    },
    {
      path: '/reset-password/:token',
      component: ResetPassword,
      props: true
    },
    {
      path: '/past-questions-and-answers',
      component: PastQandA
    },
    {
      path: '/audio-notes',
      component: AudioNotes
    },
    {
      path: '/listen/:path/:type/:id',
      component: Listen,
      props: true
    },
    {
      path: '/verify-email/:token',
      component: VerifyEmail,
      props: true
    }
  ]
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  let db = firebase.database()
  firebase.auth().onAuthStateChanged((user) => {
    if (requiresAuth && !user) {
      next('/sign-in')
    } else if (to.path === '/sign-in' && user) {
      next('/')
    } else {
      if (to.path === '/upload') {
        let teacherVerified
        db.ref('users/' + user.uid).once('value', (snapshot) => {
          teacherVerified = snapshot.val().teacherVerified
          console.log(teacherVerified)
          if (teacherVerified === false) {
            next('/')
          }
        })
      }

      next()
    }
  })
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js